import React, { useEffect, useState } from 'react';
import { useSessionStore } from '../../hooks/useSessionStore';
import axios from 'axios';
import { UsuarioContext } from '../../contexts/UsuarioContext';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import { MenuLateralAB } from "../menuLateralAA/MenuLateralAB";
import "./ContentMiClub.css";
import { HeadMiClub } from './HeadMiClub';
import img_basico from './img-video/BASICO.png';
import img_premium from './img-video/PREMIUM.png';
import img_todo_incluido from './img-video/TODO-INCLUIDO.png';
import { redirect, useNavigate } from 'react-router-dom';
import { loadStripe } from "@stripe/stripe-js";
import {useStripe} from '@stripe/react-stripe-js';
import { Stripe } from 'stripe';
import getPublishableKey from '../../stripe/publishableKey';
import getSecretKey from '../../stripe/secretKey';
import SuscripcionCard from './SuscripcionCard';
import Dashboard from './Dashboard';

const stripe_publishable_key = getPublishableKey()
// const stripe_secret_key = getSecretKey()
const stripePromise = loadStripe(stripe_publishable_key)
// const stripe = Stripe(stripe_secret_key)




const ContentMiClub = (props) => {
    const {MenuLateralAux, chageMenuLateralAux} = props;
    const [Usuario, setUsuario] = useSessionStore(UsuarioContext);

    const [miSuscripcion, setMiSuscripcion] = useState();

    const [stripeMensaje, setStripeMensaje] = useState('');
    const [isStripeUser, setStripeUser] = useState(false);
    const [conectandoStripe, setConectandoStripe] = useState(false);
    const [balance, setBalance] = useState();

    const navigate = useNavigate();

    const planBasicoPrice = 150;
    const planPremiumPrice = 950;
    const planTodoIncluidoPrice = 2000;

    const featuresBasico = ["2 Publicaciones de servicios", "Perfil básico (datos limitados)", "Análisis básico (vistas por servicio)", "Soporte estándar (correo o FAQ)", "Eventos presenciales sin descuento"];
    const featuresPremium = ["Verificación VIP", "Patrocinio de Webinar", "Soporte prioritario (chat horario laboral)", "Tarjeta digital y Agenda digital", "Formación digital"];
    const featuresTodoIncluido = ["Historia de vida de usuarios", "Herramientas de marketing", "Facturación electrónica", "Aplicaciones para usuarios Físico/Cognitivo", "Rendimiento de campañas personalizado"];

    const getSuscriptions = async () => {
        const suscriptions = await axios({
            method: 'get',
            url: window.ipdirection + 'miSuscripcion/',
            headers: {
                Authorization: 'Bearer ' + Usuario.access,
            },
        });
        setMiSuscripcion(suscriptions.data);
    }

    useEffect(() => {
        const getStripeAccount = async () => {
            const account = await axios({
                method: 'get',
                url: window.ipdirection + 'get-stripe-account/',
                headers: {
                    Authorization: 'Bearer ' + Usuario.access,
                },
            });
            if(account.data.cuenta_id){
                setStripeUser(true)
            }
            setBalance(account.data.balance.instant_available[0].amount / 100)

        }
        getStripeAccount()
    },[isStripeUser])

    useEffect(()=>{
        getSuscriptions()
    },[])

    const cancelarSuscripcion = async () => {
        let data = {
            'suscripcion_id': miSuscripcion
        }
        try{
            const response = await axios({
                method: 'post',
                url: window.ipdirection + 'cancelar-suscripcion/',
                headers: {
                    Authorization: 'Bearer ' + Usuario.access,
                },
                data: data,
            })

            if (response.data.error) {
                console.error("Error al cancelar la suscripción:", response.data.error);
                return;
            }

            window.location.reload();

        } catch (error) {
            console.error("Error en la suscripción:", error);
        }
    }

    const handleSubscription = async (price, planName) => {
        let data = {
            'plan': planName,
            'price': price
        }
        try{
            const response = await axios({
                method: 'post',
                url: window.ipdirection + 'create-subscription-session/',
                headers: {
                    Authorization: 'Bearer ' + Usuario.access,
                },
                data: data,
            })

            if (response.data.error) {
                console.error("Error al crear la sesión de Stripe:", response.data.error);
                return;
            }

            const sessionId  = response.data.sessionId;
            const stripe = await stripePromise;
            await stripe.redirectToCheckout({ sessionId });

        } catch (error) {
            console.error("Error en la suscripción:", error);
        }
    }

    const conectarStripe = async () => {
        setConectandoStripe(true);
        try {
            await axios({ 
                method: "post",
                url: window.ipdirection + 'create-stripe-account/',
                headers: {
                    Authorization: 'Bearer ' + Usuario.access,
                },
            }).then((response) => {
                const stripe = stripePromise;
                console.log('response', response.data.onboarding_link)
                window.location.href = response.data.onboarding_link;
                setConectandoStripe(false);
            }).catch((error) => {
                setStripeMensaje(error.data.error);
            });
        }
        catch (error) {
            console.error("Error al conectar con Stripe:", error);
        }
    }

    return (
        <div className='miclub-body'>
            <MenuLateralAB seleccionado={5} MenuLateralAux={MenuLateralAux} chageMenuLateralAux={chageMenuLateralAux} />
            <div className="derContentMiEmpresa">
                <HeadMiClub />
            </div>
            {
                miSuscripcion && miSuscripcion.length > 0 ?
                <Dashboard 
                    planName={miSuscripcion[0].nombrePlan} 
                    cancelarSuscripcion={cancelarSuscripcion} 
                    conectarStripe={conectarStripe} 
                    isStripeUser={isStripeUser} 
                    conectandoStripe={conectandoStripe}
                    balance={balance}
                />:
                <div className="miclub-section">
                    <div className="informacion aviso">
                        No dispone de ninguna subscripción activa.
                    </div>
                    <h2 className="miclub-title">Nuestros Planes</h2>
                    <div className="miclub-content">
                        <SuscripcionCard plan='Plan Basico' price={planBasicoPrice} img={img_basico} features={featuresBasico} handleSubscription={handleSubscription}/>
                        <SuscripcionCard plan='Plan Premium' price={planPremiumPrice} img={img_premium} features={featuresPremium} handleSubscription={handleSubscription}/>
                        <SuscripcionCard plan='Plan Todo Incluido' price={planTodoIncluidoPrice} features={featuresTodoIncluido} img={img_todo_incluido} handleSubscription={handleSubscription}/>
                    </div>
                    <div className="informacion">
                        Para conocer los privilegios que ofrecen los diferentes planes, haga click <a href='/club-cuidatia'>aquí</a>.
                    </div>
                </div>
            }
        </div>
        
    );
};

export default ContentMiClub;